import { ProviderAccessTokens } from '../model/entities';
import { ProviderType, ProviderAuthType } from '../model/types';
import aconexService from './AconexService';
import autodeskService from './AutodeskService';
import procoreService from './ProcoreService';
import sharePointService from './SharePointService';

class ProviderAuthService {
    init = async (): Promise<ProviderAuthType[]> => {
        const providerAuths: ProviderAuthType[] = [];
        try {
            const autodeskToken = await autodeskService.init();
            const sharepointToken = await sharePointService.init();
            const procoreToken = await procoreService.init();
            const aconexToken = await aconexService.init();

            if (autodeskToken) {
                providerAuths.push('AUTODESK');
            }
            if (sharepointToken) {
                providerAuths.push('SHAREPOINT');
            }
            if (procoreToken) {
                providerAuths.push('PROCORE');
            }
            if (aconexToken) {
                providerAuths.push('ACONEX');
            }
        } catch (error: any) {
            console.log(error);
        }
        return providerAuths;
    };

    isConnected = async (provider: ProviderType): Promise<boolean> => {
        let connected: boolean = false;
        switch (provider) {
            case 'ACC':
            case 'BIM360':
                connected = autodeskService.isConnected();
                break;
            case 'SHAREPOINT':
                connected = await sharePointService.isConnected();
                break;
            case 'PROCORE':
                connected = procoreService.isConnected();
                break;
            case 'ACONEX':
                connected = aconexService.isConnected();
                break;
            default:
                break;
        }
        return connected;
    };

    refresh = async (): Promise<ProviderAuthType[]> => {
        const providerAuths: ProviderAuthType[] = [];
        if (autodeskService.getCachedClientId()) {
            const accessToken = await autodeskService.getAccessToken();
            if (accessToken) {
                providerAuths.push('AUTODESK');
            }
        }
        if (procoreService.getCachedClientId()) {
            const accessToken = await procoreService.getAccessToken();
            if (accessToken) {
                providerAuths.push('PROCORE');
            }
        }
        if (aconexService.getCachedClientId()) {
            const accessToken = await aconexService.getAccessToken();
            if (accessToken) {
                providerAuths.push('ACONEX');
            }
        }
        if (sharePointService.azureEntraIdClient) {
            const accessToken = await sharePointService.getAccessToken();
            if (accessToken) {
                providerAuths.push('SHAREPOINT');
            }
        }

        return providerAuths;
    };

    getRequestHeader = async (provider: ProviderType): Promise<Record<string, string>> => {
        const headers: Record<string, string> = {};

        try {
            if (provider === 'ACC' || provider === 'BIM360') {
                const autodeskToken = await autodeskService.getAccessToken();
                if (autodeskToken) {
                    headers['Autodesk-Access-Token'] = autodeskToken;
                }
            } else if (provider === 'SHAREPOINT') {
                const sharepointToken = await sharePointService.getAccessToken();
                if (sharepointToken) {
                    headers['Microsoft-Graph-Access-Token'] = sharepointToken;
                }
            } else if (provider === 'PROCORE') {
                const procoreToken = await procoreService.getAccessToken();
                if (procoreToken) {
                    headers['Procore-Access-Token'] = procoreToken;
                }
            } else if (provider === 'ACONEX') {
                const aconexToken = await aconexService.getAccessToken();
                if (aconexToken) {
                    headers['Aconex-Access-Token'] = aconexToken;
                }
            }
        } catch (error: any) {
            console.log(error);
        }

        return headers;
    };

    getAccessTokens = async (): Promise<ProviderAccessTokens> => {
        const providerAccessTokens: ProviderAccessTokens = {};

        try {
            const autodeskToken = await autodeskService.getAccessToken();
            const sharepointToken = await sharePointService.getAccessToken();
            const procoreToken = await procoreService.getAccessToken();
            const aconexToken = await aconexService.getAccessToken();

            providerAccessTokens.autodeskAccessToken = autodeskToken;
            providerAccessTokens.microsoftGraphAccessToken = sharepointToken;
            providerAccessTokens.procoreAccessToken = procoreToken;
            providerAccessTokens.aconexAccessToken = aconexToken;
        } catch (error: any) {
            console.log(error);
        }

        return providerAccessTokens;
    };
}

const providerAuthService: ProviderAuthService = new ProviderAuthService();
export default providerAuthService;
